var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticStyle:{"height":"calc(100vh - 60px)","overflow-y":"auto"},attrs:{"fluid":""}},[(_vm.tab === 0)?_c('CreateExams'):_c('PreviewExams')],1)}
var staticRenderFns = []

export { render, staticRenderFns }